import DashboardLayout from "@/components/DashboardLayout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BlueprintToolbar from "./components/BlueprintToolbar";
import BlueprintTable from "./components/BlueprintTable";

const BlueprintsPage = () => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <DashboardLayout title={t("blueprints.blueprints")} fullHeight banner={""}>
      <div className="p-2 sm:p-4">
        <BlueprintToolbar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
        <BlueprintTable searchQuery={searchQuery} />
      </div>
    </DashboardLayout>
  );
};

export default BlueprintsPage;
